<form [formGroup]="form" #container class="w-full block">
  <div class="flex justify-between items-center w-full pr-2 mb-2">
    <label
      #subtitleLabel
      for="search"
      [class.text-label]="enabled && !showError()"
      [class.text-label-error]="enabled && showError()"
      [class.text-label-disabled]="!enabled"
    >
      {{ label }}
      <b class="text-sub-label"> {{ disabledLabel }} </b>
    </label>

    @if (showBlocker) {
      <app-lock-toggle
        [unlocked]="enabled"
        (pressed)="toggleEnabled()"
      ></app-lock-toggle>
    }
  </div>

  <div
    #inbox
    class="w-full h-10 flex items-center px-2 rounded-sm shadow-lg border bg-white"
    [class.border-blue-700]="enabled && !showError()"
    [class.border-error]="enabled && showError()"
    [class.border-gray-300]="!enabled"
  >
    <input
      #input
      type="text"
      formControlName="search"
      [placeholder]="placeholder"
      class="w-full h-full border-none outline-none focus:ring-0 px-3 placeholder:text-gray-500"
      [class.bg-gray-100]="!enabled"
      (input)="onInput()"
      (blur)="onBlur()"
    />
  </div>

  @if (filtered.length > 0 && enabled) {
    <ul class="max-h-[300px] mt-2 bg-white border border-gray-200 overflow-y-auto">
      @for (item of filtered; track $index) {
        <li
          class="p-2 hover:bg-gray-100 cursor-pointer"
          (click)="select(item)"
        >
          {{ item[labelKey] }}
        </li>
      }
    </ul>
  }

  @if (showNoResults && enabled) {
    <div class="text-red-500 text-[10px] mt-1">
      No se encontraron coincidencias
    </div>
  }

  @if (enabled && showError() && !showNoResults) {
    <div class="text-red-500 text-[10px] mt-1">
      Por favor selecciona un elemento de la lista.
    </div>
  }
</form>
